import type { VNodeProps } from '../../vnode/VNode';

export const isSheetActive = (props: VNodeProps): boolean => {
  if (!props.sheet) return false;

  if ('value' in props.sheet && !props.sheet.value) return false;

  return true;
};
